// import Services from '@/services/index';
// import VT from '@/store/types';

export default {
  // [VT.AI_JOB_DELETE]: ({}, id) => {
  //   return new Promise((resolve, reject) => {
  //     Services.aiJobs.delete(id).then((data) => {
  //       resolve(data);
  //     }).catch((data) => {
  //       reject(data);
  //     });
  //   });
  // },
};
